module.exports = __webpack_public_path__ + "static/media/Darchviz 15.90acb17e.jpg";